import { render, staticRenderFns } from "./ProductsPicker.vue?vue&type=template&id=135414ba&scoped=true&"
import script from "./ProductsPicker.vue?vue&type=script&lang=js&"
export * from "./ProductsPicker.vue?vue&type=script&lang=js&"
import style0 from "./ProductsPicker.vue?vue&type=style&index=0&id=135414ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135414ba",
  null
  
)

export default component.exports